import React from 'react';

import { trans } from '@spotahome/soyuz/client';

import SectionHeading from '@spotahome/landings-common/src/components/SectionHeading';

import './RefereeHowItWorks.scss';

const hiwContent = [
  {
    className: 'referee__hiw-search',
    number: '1',
    content: 'referee.hiw.first.item.content',
    id: 'hiw-section-first'
  },
  {
    className: 'referee__hiw-choose',
    number: '2',
    content: 'referee.hiw.second.item.content',
    id: 'hiw-section-second'
  },
  {
    className: 'referee__hiw-book',
    number: '3',
    content: 'referee.hiw.third.item.content',
    id: 'hiw-section-third'
  }
];

const RefereeHowItWorks = () => (
  <section className="referee__hiw">
    <SectionHeading text={trans('referee.hiw.title')} align="left" />
    <div className="referee__hiw-row">
      {hiwContent.map(HIWSection => (
        <div
          className={`referee__hiw-item ${HIWSection.className}`}
          key={HIWSection.id}
        >
          <span className="referee__hiw-number">{HIWSection.number}</span>
          <p className="referee__hiw-item-desc">{trans(HIWSection.content)}</p>
        </div>
      ))}
    </div>
  </section>
);

export default RefereeHowItWorks;
